import { API_BASE_URL } from "../../config";
import { Session } from "./session";

export const refreshJwtToken = async () => {
  try {
console.log("refreshJwtToken CALLED");
    const refreshToken =
      Session.getRefreshToken();
 console.log("Refresh Token:", refreshToken);
    if (!refreshToken) {
      return false;
    }
console.log("refreshJwtToken CALLED");
    const response = await fetch(
      `${API_BASE_URL}/api/Auth/refresh-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          refreshToken
        })
      }
    );
   console.log("Refresh Status:", response.status);
    if (!response.ok) {

      Session.clear();
     window.location.replace("/login");
      return false;
    }

    const data = await response.json();

    // Save new JWT token
    sessionStorage.setItem( "aim_token", data.token );
    if (data.refreshToken) {
      sessionStorage.setItem("aim_refresh_token", data.refreshToken);
    }
    // Update expiry time
    sessionStorage.setItem(
      "aim_exp",
      (
        Date.now() +
        60 * 60 * 1000
      ).toString()
    );

    console.log("JWT refreshed successfully");

    return true;

  } catch (error) {

    console.error(
      "Token refresh failed:",
      error
    );

    Session.clear();
   window.location.replace("/login");
    return false;
  }
};